import { Route, Routes, useLocation } from 'react-router-dom';
import MemberLifeCycleManagement from './components/MemberLifeCycleManagement';
import OnboardingStepper from './components/OnboardingStepper';

export default function MemberManagement() {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/" element={<MemberLifeCycleManagement />} />
      <Route path="/sync" element={<OnboardingStepper />} />
    </Routes>
  );
}
